import { Injectable } from '@angular/core';
import { LearnComponent } from './learn.component';
import { Headers, Response, Http, RequestOptions } from '@angular/http';
import { map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import "rxjs/Rx";
import 'rxjs/add/operator/toPromise';
import { Observable } from "rxjs/Observable";
import { DynamicMessageComponent } from '../../components/dynamicMessage/dynamicMessage.component';
import { HttpService } from '../../services/httpService';
import * as $ from 'jquery';
import { ChatMessage } from '../../entities/chat-message.module';
import { ApiService } from '../../services/api.service';



@Injectable()
export class LearnService {
    

    mychatroomUrl: string = 'entry/mychatroom/?requestType=JSON';

    constructor(private http: Http, private httpService: HttpService,
        private apiService: ApiService) {
    }
    getNowTime(): string {
        var dd = new Date();
        var y = dd.getFullYear();
        var m = dd.getMonth();
        var d = dd.getDate();
        var h = dd.getHours(); 
        var mi = dd.getMinutes(); 
        var s = dd.getSeconds();
        var nyr = y+"-"+(m+1)+"-"+d;
        return nyr+" "+(h<10?('0'+h):(h)) + ':' + (mi<10?('0'+mi):(mi)) + ':' + (s<10?('0'+s):(s));
      }
       
    getLoginUserName():  string[] {
        let bb = ' -- ';
        let domain = '--';
            $.ajax({
               url: 'entry/mychatroom?requestType=JSON&jsMethod=getLoginUserName',
               type: 'POST',
               async: false,
               data: {list_item: 'selected_from_list'},
               success: function(result){
                   // var json = $.parseJSON(result);
                  bb = result.userName;
                  domain = result.domainId;
               },
               error: function(e){
                   alert('error:' + e);
               }
            });
        return [bb, domain];
    }

    
    sendMessage2JackExt(message: any, mychatroomComponent: LearnComponent): string {
        this.apiService.post('/api/learn/'+mychatroomComponent.urllink, message).subscribe((respnose:any)=>{
            mychatroomComponent.done(respnose);
        }, (error:any)=>{
            mychatroomComponent.done(error, true);
        });
        
        return null;
      }
 

    extractData(res: Response) {
        let mychatroomData: any = res.json();
        return mychatroomData;
    }

    handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}
